export function omit<T extends object>(obj: T, fields: (keyof T)[]) {
  const shallowCopy = Object.assign({}, obj) as T;
  for (let i = 0; i < fields.length; i += 1) {
    const key = fields[i];
    delete shallowCopy[key as keyof typeof shallowCopy];
  }
  return shallowCopy;
}
